export default "__VITE_ASSET__BHgBF1IG__"